import i18n from '../../../utils/i18n/i18n';

export enum BackendErrorCodes {
  FileAlreadyExist = 409,
}

export const getErrorMessage = (errorCode: any): string => {
  if (errorCode === BackendErrorCodes.FileAlreadyExist) {
    return i18n.t('file-manager.compress.errors.already-exist');
  }

  return i18n.t('file-manager.compress.errors.default');
};
